import React, { Component } from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import NoSsr from '@material-ui/core/NoSsr';
// import Select from 'react-select';
import Select from 'react-select/async';

import withStyles from '@material-ui/core/styles/withStyles';
import axios from 'axios';
import styled from 'styled-components';

import { emphasize } from '@material-ui/core/styles/colorManipulator';
import { asField } from 'informed';

import {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
} from './SelectComponents';

const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

const StyledFormControl = styled(FormControl)`
  width: 100%;
`;

class BankSelect extends Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();
  }

  static componentDidMount() {
    const { fieldState, type, fetchBanks } = this.props;
    if (type === 'banks' && fieldState.value) fetchBanks();
  }

  // eslint-disable-next-line no-unused-vars
  handleChange = name => option => {
    const { fieldApi, onChange } = this.props;
    if (option) {
      const { value } = option;
      fieldApi.setValue(value);
      if (onChange) {
        onChange(value);
      }
    }
  };

  handleFilterBanks = inputValue => {
    if (!inputValue) {
      return Promise.resolve([]);
    }
    const { banksBaseUrl: url } = this.props;
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      range: '1-10000',
    };
    const params = {
      _fields: 'rec_name',
      // query: 'id,rec_name, bic',
      rec_name: `~${inputValue}*` || '~*',
    };
    const getOptions = () => ({
      method: 'GET',
      url,
      params,
      headers,
      json: true,
      crossdomain: true,
      withCredentials: true,
    });

    return axios(getOptions())
      .then(response => {
        const options = response.data.map(bank => ({
          value: bank.bic,
          label: bank.rec_name,
        }));
        return options;
      })
      .catch(() => []);
  };

  render() {
    const { fieldApi, fieldState, ...props } = this.props;
    const { value } = fieldState;
    // const { setTouched } = fieldApi;
    const {
      theme,
      classes,
      isDisabled,
      // isLoading,
      isClearable,
      isSearchable,
      // onChange,
      // onBlur,
      field,
      // initialValue,
      // children,
      multiple,
      /* forwardedRef, //Warning: React does not recognize the `forwardedRef` prop on a DOM element. */
      label = '',
      placeholder = '',
      // id = String(Math.floor(Math.random() * 1e8)),
      helperText = '',
      options = [],
      // type,
      required,
      // ...rest
    } = props;

    const cleanValue = value ? options.find(option => option.value === value) : undefined;

    const selectStyles = {
      input: base => ({
        ...base,
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit',
        },
      }),
    };
    return (
      <>
        <NoSsr>
          <StyledFormControl error={!!fieldState.error}>
            <Select
              required={required}
              classes={classes}
              styles={selectStyles}
              isDisabled={isDisabled}
              isClearable={isClearable}
              isSearchable={isSearchable}
              multiple={multiple}
              ref={this.selectRef}
              name={field}
              cacheOptions
              defaultOptions={options}
              loadOptions={_.debounce(this.handleFilterBanks, 500)}
              defaultValue={cleanValue || (multiple ? [] : '')}
              // value={cleanValue || (multiple ? [] : '')}
              components={components}
              placeholder={placeholder}
              textFieldProps={{
                label: required ? `${label} *` : label,
                InputLabelProps: {
                  shrink: true,
                },
              }}
              onChange={this.handleChange(field)}
              disabled
            />
            <FormHelperText>{fieldState.error || helperText}</FormHelperText>
          </StyledFormControl>
        </NoSsr>
      </>
    );
  }
}

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  input: {
    display: 'flex',
    padding: 0,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  singleValue: {
    fontSize: 14,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 14,
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing.unit * 2,
  },
});

BankSelect.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    })
  ),
  fetchBanks: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  fieldApi: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  fieldState: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  strings: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
  type: PropTypes.string.isRequired,
  required: PropTypes.bool,
  banksBaseUrl: PropTypes.func,
};

BankSelect.defaultProps = {
  options: [],
  fetchBanks: id => {
    console.log('fetchBanks::', id); // eslint-disable-line no-console
  },
  strings: {
    'lenders.label': 'Lender',
  },
  isDisabled: false,
  isLoading: false,
  isClearable: false,
  isSearchable: true,
  required: true,
  banksBaseUrl: '/api/bank',
};

export default asField(withStyles(styles, { withTheme: true })(BankSelect));
